export default "__VITE_ASSET__CPXBBA61__"